import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initHeaderFunctions() {
  const sp = window.matchMedia(MEDIA_QUERIES.smartphone);
  const sp_x_tablet = window.matchMedia(MEDIA_QUERIES.sp_x_tablet);
  const pc = window.matchMedia(MEDIA_QUERIES.pc);

  //pc 
  (function(){
    const navLinkToggle = $('.js-navLinkToggle');
    navLinkToggle.on('mouseenter', function() {
      if(sp.matches) return;
      
      $(this).find('.navLink__sub').addClass('is-open');
    })

    navLinkToggle.on('mouseleave', function() {
      if(sp.matches) return;
      
      $(this).find('.navLink__sub').removeClass('is-open');
    })
  })();


  //sp
  (function(){
    //sp menu toggle
    const spMenuToggle = $('.js-hamburgerMenu');

    spMenuToggle.on('click', function() {
      if(pc.matches) return;
      
      $(this).siblings('.header__nav').toggleClass('is-spOpen');
    })


    //click other part to close sp menu
    $(document).on('click', function(e) {
      if(sp_x_tablet.matches && !$(e.target).closest('.header__nav').length && !$(e.target).closest('.js-hamburgerMenu').length) {
        spMenuToggle.siblings('.header__nav').removeClass('is-spOpen');
      }
    });



    const navLinkToggle = $('.js-navLinkToggle');

    //sp accordion
    navLinkToggle.on('click', function() {
      if(pc.matches) return;
      
      $(this).toggleClass('is-spAccordionOpen');
      $(this).find('.navLink__sub').slideToggle(300);
    })

    pc.addEventListener('change', function(e){
      if(e.matches){
        spMenuToggle.siblings('.header__nav').removeClass('is-spOpen');
        navLinkToggle.removeClass('is-spAccordionOpen');
        navLinkToggle
          .find('.navLink__sub')
          .slideUp(400, 'linear', function () {
            $(this).css('display', '');
          });
      }
    });

  })();





  
}
